module.exports = __webpack_public_path__ + "static/media/screen.2df6de4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/recipe/screen.png
// module id = 63
// module chunks = 0